/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
    removeOOSProductSwatches: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductSwatch', {
            name: 'Customize swatches',
            enabled: true,
            apply: () => ({
                props: (props) => {
                    props.maxItem = 100; // Show all swatches by increasing number of swatches displayed to 100 (optional)
                    return props;
                },
                afterRender(element) {
                    try {
                        const swatchOptions = element?.getParams()?.props?.options;
                        const productData =
                            componentRegistry.getNearestParentElm(element, 'ProductItemWidget')?.getParams()?.props?.product ||
                            componentRegistry.getNearestParentElm(element, 'QuickView')?.getParams()?.props?.productData;
                      
                        if (swatchOptions?.length && productData) {
                            const productVariants = productData.variants || [];
                            /* Start-Boost-36250 */
                            let productId = productData.id;
                            if (productData?.split_product) {
                                productId = productData.variant_id;
                            }
                            let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                            /* End-Boost-36250 */

                            // console.log(productData.title);
                            swatchOptions.forEach((option) => {
                                const optionValue = option.value;
                                option.available = checkOptionStatus(productVariants, optionValue);
                                if (!option.available) {
                                    // const swatchOption = document.querySelector(`label[for*="${option.id}"]`);
                                    /* Start-Boost-36250 */
                                    // const swatchOption = productItem.querySelector(`input[value="${optionValue}"]`);
                                    const swatchOption = productItem.querySelector(`input[value='${optionValue}']`);
                                    /* End-Boost-36250 */
                                    if (swatchOption && swatchOption.closest('.boost-sd__product-swatch-option')) {
                                        swatchOption.closest('.boost-sd__product-swatch-option').classList.add('sold-out');
                                    }
                                }
                            });
                        }
                    } catch (error) {
                        console.warn(error)
                    }
                },
            }),
        });
    },
};

function checkOptionStatus(variants, optionValue) {
    // console.log(variants, optionValue)
    for (let i = 0; i < variants.length; i++) {
        const variant = variants[i];
        // const variantOptions = variant.title?.split(' / ') || [];
        // if (variantOptions.some((option) => option.toLowerCase() === optionValue.toLowerCase() && variant.available)) {
        //     return true;
        // }
        /* Start-Boost-36250 */
        const variantOptions = variant.original_merged_options.filter(function(e) { 
            return e == 'color:' + optionValue || e == 'size:' + optionValue; 
        });
        if (typeof variantOptions[0] !== 'undefined' && variant.available) {
            return true;
        }
        /* End-Boost-36250 */
    }
    return false;
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customize.removeOOSProductSwatches,
]);